import React from 'react';
import './style.css';
// import Logo from './Logo';
function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {/* <Logo width={40} /> */}
      <div id="loading-bar"></div>
    </div>
  );
}

export default Loading;
